import ProductMigrationState from '@/models/Products/ProductMigrations/ProductMigrationState';

export default (productMigrationState: ProductMigrationState) => {
    let returnVal = "Undefined";
    switch (productMigrationState) {
        case ProductMigrationState.Pending:
            returnVal = "Pending"
            break;
        case ProductMigrationState.InProgress:
            returnVal = "In Progress"
            break;
        case ProductMigrationState.Complete:
            returnVal = "Complete"
            break;
    }
    return returnVal;
}